export const FETCH_TIME_SLOTS_REQUEST = 'FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_FAILURE = 'FETCH_TIME_SLOTS_FAILURE';